import ColorPicker from '../ui/ColorPicker';
import ToggleGroup from '../ui/ToggleGroup';
import './WizardStep.css';

const colorModeOptions = [
  { 
    value: 'light', 
    label: 'Light',
    icon: '☀️'
  },
  { 
    value: 'dark', 
    label: 'Dark',
    icon: '🌙'
  }
];

const fontStyleOptions = [
  { 
    value: 'sans', 
    label: 'Clean',
    icon: (
      <span style={{ fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 500 }}>Aa</span>
    )
  },
  { 
    value: 'serif', 
    label: 'Classic',
    icon: (
      <span style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}>Aa</span>
    )
  },
  { 
    value: 'mono', 
    label: 'Tech',
    icon: (
      <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.9em' }}>Aa</span>
    )
  },
  { 
    value: 'display', 
    label: 'Editorial',
    icon: (
      <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontStyle: 'italic' }}>Aa</span>
    )
  },
  { 
    value: 'rounded', 
    label: 'Friendly',
    icon: (
      <span style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 600 }}>Aa</span>
    )
  },
  { 
    value: 'elegant', 
    label: 'Luxury',
    icon: (
      <span style={{ fontFamily: "'Cormorant Garamond', Garamond, serif", fontWeight: 500, letterSpacing: '0.05em' }}>Aa</span>
    )
  }
];

export default function StepVisuals({ formData, errors, onChange }) {
  const { visuals } = formData;

  const handleChange = (field, value) => {
    onChange('visuals', field, value);
  };

  return (
    <div className="wizard-step">
      <div className="wizard-step__header">
        <h2 className="wizard-step__title">Define your visual style</h2>
        <p className="wizard-step__description">
          Choose colors and typography that reflect your brand's personality.
        </p>
      </div>

      <div className="wizard-step__content">
        <ColorPicker
          label="Accent Color"
          value={visuals.colorSeed}
          onChange={(color) => handleChange('colorSeed', color)}
        />

        <ToggleGroup
          label="Color Mode"
          options={colorModeOptions}
          value={visuals.colorMode}
          onChange={(mode) => handleChange('colorMode', mode)}
        />

        <ToggleGroup
          label="Font Style"
          options={fontStyleOptions}
          value={visuals.fontStyle}
          onChange={(style) => handleChange('fontStyle', style)}
        />
      </div>
    </div>
  );
}
